import React, { useEffect } from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { bookingsUoUBookingFormClickSrc16Evid83 } from '@wix/bi-logger-bookings-data/v2';
import { Modal } from '../../Modal';
import { useFormActions } from '../../Hooks/useFormActions';
import {
  BookingFormClickActions,
  BookingFormClickComponents,
  BookingFormClickValues,
} from '../../../../types/biLoggerTypes';
import { ParticipantConfirmationModalDataHooks } from './dataHooks';

export enum ParticipantConfirmationKeyPrefix {
  LoginClears = 'bookings.form.collectParticipant.loginClearsWarning',
  AddWithPlan = 'bookings.form.collectParticipant.addWithPlanWarning',
  Remove = 'bookings.form.collectParticipant.removeParticipantWarning',
}

export type ParticipantConfirmationModalProps = {
  keyPrefix: ParticipantConfirmationKeyPrefix;
  biComponent: BookingFormClickComponents;
  onConfirm: () => void;
  onClose: () => void;
};

export const ParticipantConfirmationModal: React.FC<
  ParticipantConfirmationModalProps
> = ({ keyPrefix, biComponent, onConfirm, onClose }) => {
  const { t } = useTranslation();
  const { logBi } = useFormActions();

  useEffect(() => {
    logBi([
      bookingsUoUBookingFormClickSrc16Evid83({
        component: biComponent,
        action: BookingFormClickActions.Load,
      }),
    ]);
  }, [logBi, biComponent]);

  const reportClick = (value: BookingFormClickValues) =>
    logBi([
      bookingsUoUBookingFormClickSrc16Evid83({
        component: biComponent,
        action: BookingFormClickActions.Click,
        value,
      }),
    ]);

  const cancel = () => {
    reportClick(BookingFormClickValues.Cancel);
    onClose();
  };

  return (
    <Modal
      dataHook={ParticipantConfirmationModalDataHooks.ROOT}
      modalTitle={t(`${keyPrefix}.title`)}
      modalSubtitle={t(`${keyPrefix}.body`)}
      primaryButton={{
        label: t(`${keyPrefix}.confirm`),
        onClick: () => {
          reportClick(BookingFormClickValues.Confirm);
          onConfirm();
        },
      }}
      secondaryButton={{ label: t(`${keyPrefix}.cancel`), onClick: cancel }}
      onClose={cancel}
    />
  );
};
